import React from "react"
import { Link } from "gatsby"
// import { Box } from "theme-ui"
import useLang from "../../hooks/useLang"
import { Icon } from "react-icons-kit"
import { phone } from "react-icons-kit/fa/phone"
import { whatsapp } from "react-icons-kit/fa/whatsapp"
import { videoCamera } from "react-icons-kit/fa/videoCamera"
import { mapMarker } from "react-icons-kit/fa/mapMarker"
import { arrowRight } from "react-icons-kit/fa/arrowRight"
import { arrowLeft } from "react-icons-kit/fa/arrowLeft"
import "./style.css"

const DiscussProject = () => {
  const isAr = useLang() === "ar"

  const title = isAr ? "كيف تريد أن نبدأ؟" : "How Would You Like to Start?"
  const subtitle = isAr
    ? "اختر الطريقة الأنسب لك للتواصل معنا وسنرد عليك في أقرب وقت"
    : "Choose the most convenient way to reach us and we'll get back to you promptly"

  const options = [
    {
      id: 1,
      icon: phone,
      title: isAr ? "اتصل بنا" : "Call Us",
      description: isAr ? "تحدث مباشرة مع فريقنا" : "Speak directly with our team",
      action: isAr ? "اتصل الآن" : "Call Now",
      link: "tel:+971544111919",
      color: "#7e9822",
    },
    {
      id: 2,
      icon: whatsapp,
      title: isAr ? "واتساب" : "WhatsApp",
      description: isAr ? "راسلنا على واتساب" : "Message us on WhatsApp",
      action: isAr ? "أرسل رسالة" : "Send Message",
      link: "https://wa.me/971544111919",
      color: "#7e9822",
    },
    {
      id: 3,
      icon: videoCamera,
      title: isAr ? "اجتماع أونلاين" : "Online Meeting",
      description: isAr ? "احجز اجتماع افتراضي" : "Schedule a virtual meeting",
      action: isAr ? "احجز الآن" : "Book Now",
      link: "mailto:info@benchmark.ae?subject=Online Meeting Request",
      color: "#7e9822",
    },
    {
      id: 4,
      icon: mapMarker,
      title: isAr ? "زر مكتبنا" : "Visit Our Office",
      description: isAr ? "مظفر 32، قطعة 15، أبوظبي" : "Mussafah 32, Plot 15, Abu Dhabi",
      action: isAr ? "احصل على الاتجاهات" : "Get Directions",
      link: "https://maps.app.goo.gl/wzEy94M7ham56sfF8",
      color: "#7e9822",
    },
  ]

  const backText = isAr ? "العودة للرئيسية" : "Back to Home"
  const arrowIcon = isAr ? arrowLeft : arrowRight

  return (
    <div className="discuss-project-page">
      <div className="discuss-project-content">
        <div className="container">
          <div className="discuss-project-header">
            <div className="b-breadcrumbs">
              <ul className="list-inline">
                <li>
                  <Link to={`${isAr ? "/ar" : ""}/`}>
                    {isAr ? "الرئيسية" : "Home"}
                  </Link>
                </li>
                <li className="current">
                  {isAr ? "ناقش مشروعك" : "Discuss Project"}
                </li>
              </ul>
            </div>

            <h1 className="discuss-project-title">{title}</h1>
            <p className="discuss-project-subtitle">{subtitle}</p>
          </div>

          <div className="discuss-options-grid">
            {options.map((option, index) => (
              <div
                key={option.id}
                className="discuss-option-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="option-icon-wrapper">
                  <div
                    className="option-icon"
                    style={{ backgroundColor: `${option.color}15` }}
                  >
                    <Icon
                      icon={option.icon}
                      size={32}
                      style={{ color: option.color }}
                    />
                  </div>
                  <div
                    className="option-number"
                    style={{ backgroundColor: option.color }}
                  >
                    {option.id}
                  </div>
                </div>

                <h3 className="option-title">{option.title}</h3>
                <p className="option-description">{option.description}</p>

                <a
                  href={option.link}
                  target={option.link.startsWith("http") ? "_blank" : "_self"}
                  rel="noopener noreferrer"
                  className="option-action-btn"
                  style={{ borderColor: option.color, color: option.color }}
                >
                  <span>{option.action}</span>
                  <Icon icon={arrowIcon} size={14} />
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DiscussProject
